const tooltip1 = 'Vypĺňa sa nepovinne, ak sa predkladateľ rozhodne nepovinné údaje vyplniť, uvedie ich slovne.';
const tooltip2 = 'Prostredníctvom právneho a informačného portálu Slov-Lex.';
const tooltip3 = 'Podľa Jednotnej metodiky na posudzovanie vybraných vplyvov a podľa § 2 zákona o tripartite.';
const tooltip4 = 'Vrátane odborových organizácií a ich združení.';
const tooltip5 = 'Vyplniť iba v prípade, ak sa záverečné posúdenie vybraných vplyvov uskutočnilo v zmysle'
  + ' bodu 9.1. jednotnej metodiky.';
const tooltip6 = 'Vyplniť iba v prípade, ak materiál nie je zahrnutý do Plánu práce vlády Slovenskej '
  + 'republiky alebo Plánu legislatívnych úloh vlády Slovenskej republiky.';
const tooltip7 = 'Posudzovanie  sa  týka  len  zmien  v  I.  a  II.  pilieri  univerzálneho  systému '
  + ' dôchodkového  zabezpečenia s identifikovaným dopadom od 0,1 % HDP (vrátane) na dlhodobom horizonte.';

export {
  tooltip1, tooltip2, tooltip3, tooltip4, tooltip5, tooltip6, tooltip7,
};
